import * as React from "react";
function SvgGraph(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={4}
        d="M0 4h32M0 12h24M0 20h12M0 28h6"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGraph);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
